import { Chip } from "@aircall/ds";

import { getClosestColor } from "@/helpers/colors/colors.helpers";
import { useLuminance } from "@/hooks/useLuminance/useLuminance";

import { TAG_COLORS, THRESHOLD } from "./TagBeautified.constants";
import { TagBeautifiedProps } from "./TagBeautified.decl";

export function TagBeautified({
  color,
  children,
  "data-test": dataTest = "tag-beautified",
}: TagBeautifiedProps) {
  const { textColor } = useLuminance({
    color,
    threshold: THRESHOLD,
  });

  const { color: backgroundColor } = getClosestColor(color, TAG_COLORS);

  return (
    <Chip data-test={dataTest} style={{ backgroundColor, color: textColor }}>
      {children}
    </Chip>
  );
}
